import {useCallback, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useSaltEdge} from '../../../../hooks';
import {openBankingActions} from '../../../../state/actions/openBanking.actions';

const ConnectAccountModal = () => {
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const connectUrl = useSelector((state) => state.openBanking?.connectUrl ?? null);

  const closePopup = useCallback(() => {
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.close();
    }
    popupRef.current = null;
  }, []);

  const handleClose = useCallback(() => {
    closePopup();
    dispatch(openBankingActions.closeConnectModal());
  }, [closePopup, dispatch]);

  const handleSuccess = useCallback(({connectionId}) => {
    // A new connection's accounts sync asynchronously and are empty at this point;
    // they arrive later via the CONNECTION_ACTIVE websocket, which re-fetches
    // getConnection — that fetch appends the accounts and grants them in
    // accountAccessIds. So there is nothing to reload here: just pull the
    // connection and close the popup.
    if (connectionId) {
      dispatch(openBankingActions.getConnection({
        connectionId,
        successCallback: (connection) => {
          const firstAccount = connection.accounts?.[0];
          if (firstAccount) {
            dispatch(openBankingActions.setFirstNewAccountId(firstAccount.id));
          }
        },
        errorCallback: () => dispatch(openBankingActions.clearFirstNewAccountId()),
      }));
    }
    handleClose();
  }, [dispatch, handleClose]);

  useSaltEdge({onSuccess: handleSuccess, onClose: handleClose});

  useEffect(() => {
    if (!connectUrl) return;
    const width = 420;
    const height = 720;
    const left = window.screen.availLeft + (window.screen.availWidth - width) / 2;
    const top = window.screen.availTop + (window.screen.availHeight - height) / 2;
    popupRef.current = window.open(
      connectUrl,
      'SaltEdgeWidget',
      `width=${width},height=${height},top=${top},left=${left}`,
    );
  }, [connectUrl]);

  return null;
};

export default ConnectAccountModal;
